/**
 * Utilitários para Google Calendar e ICS
 */

import type { BookingData } from "../types";

/**
 * Gera link do Google Calendar para adicionar evento
 */
export function buildGoogleCalendarUrl(booking: BookingData): string {
  const { date, time, serviceName, serviceDuration = 60, name } = booking;

  const startDateTime = `${date}T${time}:00`;
  const start = new Date(startDateTime);
  const end = new Date(start.getTime() + serviceDuration * 60000);

  const formatDateTime = (d: Date) => {
    return d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  };

  const title = serviceName ? `Agendamento: ${serviceName}` : "Agendamento de Serviço";
  const details = `Cliente: ${name}`;

  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: title,
    dates: `${formatDateTime(start)}/${formatDateTime(end)}`,
    details,
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

/**
 * Gera e baixa arquivo ICS para calendário
 */
export function downloadIcsFile(booking: BookingData): void {
  const { date, time, serviceName, serviceDuration = 60, name } = booking;

  const startDateTime = `${date}T${time}:00`;
  const start = new Date(startDateTime);
  const end = new Date(start.getTime() + serviceDuration * 60000);

  const formatIcsDate = (d: Date) => {
    return d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  };

  const title = serviceName ? `Agendamento: ${serviceName}` : "Agendamento de Serviço";
  const description = `Cliente: ${name}`;

  const icsContent = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `DTSTART:${formatIcsDate(start)}`,
    `DTEND:${formatIcsDate(end)}`,
    `SUMMARY:${title}`,
    `DESCRIPTION:${description}`,
    "STATUS:CONFIRMED",
    "SEQUENCE:0",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");

  const blob = new Blob([icsContent], { type: "text/calendar" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "agendamento.ics";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
